"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box as ChakraBox, Spinner, forwardRef } from "@chakra-ui/react";
const CircleSpinner = forwardRef((props, ref) => {
    const variant = (props === null || props === void 0 ? void 0 : props.variant) || "default";
    if (variant === "withBackground") {
        return (_jsx(ChakraBox, Object.assign({ ref: ref, sx: {
                width: "3rem",
                height: "3rem",
                backgroundColor: "semantic.surface.1",
                borderRadius: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }, shadow: "medium" }, { children: _jsx(Spinner, Object.assign({}, props)) })));
    }
    return _jsx(Spinner, Object.assign({}, props));
});
export default CircleSpinner;
//# sourceMappingURL=CircleSpinner.js.map